// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3pP8z","actionsCol":"EnrolledClinics_actionsCol__1O5b9"};